import { useState, useEffect } from 'react'

import { http } from '@itau-loans-www/services'
import { goTo, isClient } from '@itau-loans-www/utils'

export const usePhotoError = () => {
  const [proposal, setProposal] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [isAlertVisible, setIsAlertVisible] = useState(true)

  const closeAlert = () => setIsAlertVisible(false)

  useEffect(() => {
    http.proposal
      .getPendingPhoto()
      .then(({ simulation }) => setProposal(simulation))
      .catch(() => {
        goTo('final-screen-error-proposal')
      })
      .finally(() => setIsLoading(false))
  }, [])

  const handleSendProposalAsIs = () => {
    setIsLoading(true)

    http.proposal
      .putPendingPhoto()
      .then(({ final_screen }) => goTo(final_screen))
      .catch(() => {
        goTo('final-screen-error-proposal')
      })
      .finally(() => setIsLoading(false))
  }

  const handleGetNewOffer = async () => {
    try {
      setIsLoading(true)

      const { url } = await http.proposal.crossSell()
      isClient() && window.location.assign(url)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    proposal,
    isLoading,
    closeAlert,
    isAlertVisible,
    handleGetNewOffer,
    handleSendProposalAsIs
  }
}
